/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs'; 
import { DischargeEntryApi } from '../api/dischargeentry.api';
import { switchMap, map } from 'rxjs/operators';
import { DischargeEntryData, DischargeEntry } from '../../../interfaces/masters/dischargeentry';

@Injectable()
export class DischargeEntryService extends DischargeEntryData {

  constructor(private api: DischargeEntryApi) {
    super();
  }


  list(url: string): Observable<DischargeEntry[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<DischargeEntry>{
      return this.api.getById(url);
  }

  create(url: string, data:DischargeEntry): Observable<DischargeEntry[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:DischargeEntry): Observable<DischargeEntry> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
